<template>
  <div class="container">
    <ul class="card-list">
      <li class="card-item">
        <Card
          title="供应商白名单"
          imgName="note"
          :titleList="titleList1"
          :briefList="briefList1"
          @moreClick="handleClick('Supplier')"
        />
      </li>
      <li class="card-item">
        <Card
          title="原辅料检验报告"
          imgName="circle"
          :titleList="titleList2"
          :briefList="briefList2"
          @moreClick="handleClick('RawAccessory')"
        />
      </li>
      <li class="card-item">
        <Card
          title="成品检验报告"
          imgName="box"
          :titleList="titleList3"
          :briefList="briefList3"
          @moreClick="handleClick('Product')"
        />
      </li>
      <li class="card-item">
        <Card
          title="药品生产入库"
          imgName="download"
          :titleList="titleList4"
          :briefList="briefList4"
          @moreClick="handleClick('DrugStock')"
        />
      </li>
      <li class="card-item">
        <Card
          title="环境数据"
          imgName="leaf"
          :titleList="titleList5"
          :briefList="briefList5"
          @moreClick="handleClick('Environment')"
        />
      </li>
      <li class="card-item">
        <Card
          title="视频监控"
          imgName="ellipsis"
          :titleList="titleList6"
          :briefList="briefList6"
          @moreClick="handleClick('Other')"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import Card from 'components/card/card';

export default {
  data() {
    return {
      titleList1: [],
      briefList1: [],
      titleList2: [],
      briefList2: [],
      titleList3: [],
      briefList3: [],
      titleList4: [],
      briefList4: [],
      titleList5: [],
      briefList5: [],
      titleList6: [],
      briefList6: []
    };
  },
  mounted() {
    this.loadSupplier();
    this.loadRawAccessory();
    this.loadProduct();
    this.loadDrugStock();
    this.loadEnvironment();
    this.loadOthers();
  },
  methods: {
    loadSupplier() {
      this.$request({
        url: 'rest/production/checkSupplierList'
      }).then(res => {
        this.titleList1 = [
          {
            text: '相关生产企业数量',
            num: res.sup_ent_num
          },
          {
            text: '供应商数量',
            num: res.sup_num
          }
        ];
        this.briefList1 = res.list
          .map(item => ({
            time: item.regTime,
            brief: `${item.organName}完成供应商${item.supplierName}的注册`
          }))
          .slice(0, 5);
      });
    },
    loadRawAccessory() {
      this.$request({
        url: 'rest/production/checkRawReportList'
      }).then(res => {
        this.titleList2 = [
          {
            text: '相关生产企业数量',
            num: res.raw_ent_num
          },
          {
            text: '原辅料检验报告数量',
            num: res.raw_report_num
          },
          {
            text: '相关原辅料批次',
            num: res.raw_batch_num
          }
        ];
        this.briefList2 = res.list
          .map(item => ({
            time: item.reportDate,
            brief: `${item.organName}完成${item.materielName}检验报告`
          }))
          .slice(0, 5);
      });
    },
    loadProduct() {
      this.$request({
        url: 'rest/production/checkQualityReportList'
      }).then(res => {
        this.titleList3 = [
          {
            text: '相关生产企业数量',
            num: res.quality_ent_num
          },
          {
            text: '成品检验报告数量',
            num: res.quality_report_num
          },
          {
            text: '相关成品批次',
            num: res.quality_batch_num
          }
        ];
        this.briefList3 = res.list
          .map(item => ({
            time: item.examineDate,
            brief: `${item.organName}完成${item.inspectionName}检验报告`
          }))
          .slice(0, 5);
      });
    },
    loadDrugStock() {
      this.$request({
        url: 'rest/production/checkDrugList'
      }).then(res => {
        this.titleList4 = [
          {
            text: '相关生产企业数量',
            num: res.drug_ent_num
          },
          {
            text: '生产入库药品批次',
            num: res.drug_batch_num
          },
          {
            text: '生产入库药品数量',
            num: res.drug_in_num
          }
        ];
        this.briefList4 = res.list
          .map(item => ({
            time: item.issuanceDate,
            brief: `${item.organName}完成${item.productName}生产入库`
          }))
          .slice(0, 5);
      });
    },
    loadEnvironment() {
      this.$request({
        url: 'rest/production/checkTempList'
      }).then(res => {
        this.titleList5 = [
          {
            text: '相关生产企业数量',
            num: res.temp_ent_num
          },
          {
            text: '温湿度监测点数量',
            num: res.temp_num
          }
        ];
        this.briefList5 = res.list
          .map(item => ({
            time: item.genTime,
            brief: `${item.entName}温湿度监测点${item.storehouseName}${item.storehouseAddress}完成温湿度采集`
          }))
          .slice(0, 5);
      });
    },
    loadOthers() {
      this.$request({
        url: 'rest/production/checkOtherList'
      }).then(res => {
        this.titleList6 = [
          {
            text: '相关生产企业数量',
            num: res.pro_video_num
          },
          {
            text: '视频监控点数量',
            num: res.video_num
          }
        ];
        this.briefList6 = res.list
          .map(item => ({
            time: item.issuanceDate,
            brief: item.organ_name
          }))
          .slice(0, 5);
      });
    },
    handleClick(type) {
      this.$router.push({
        path: `/page/productingEnterprise/monitorDetail/${type}`
      });
    }
  },
  components: {
    Card
  }
};
</script>

<style lang="stylus" scoped>
.card-list
  overflow hidden
.card-item
  float left
  margin-right 45px
  margin-bottom 30px
  &:nth-child(4n)
    margin-right 0
</style>
